module.exports = __webpack_public_path__ + "img/wx_xcx.826be125.png";